export default {
  // Firebase configuration
  firebaseConfig: {
    apiKey: "AIzaSyDnWjDRSBk8LK8VzApwTmj-MRD0uz_6d8A",
    authDomain: "apoflex.firebaseapp.com",
    databaseURL: "https://apoflex.firebaseio.com",
    projectId: "apoflex",
    storageBucket: "apoflex.appspot.com",
    messagingSenderId: "194070331299",
    appId: "1:194070331299:web:aaf5e3d6576c850d0b6416",
    measurementId: "G-PF5KTJQ269"
  }
};
